import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { TOLL_PATH } from '../../../../config/paths';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import TollForm from './TollForm';
import { postToll } from '../../../../actions';

const NewToll = ({ breadcrumbs, dispatchPostToll }) => {
  const onSubmit = (formValues) => {
    const pricePerAxle = Number(formValues.pricePerAxle);
    const taxPrePaymentPerAxle = Number(formValues.taxPrePaymentPerAxle);
    const electronic = Boolean(formValues.electronic);

    const newFormValues = {
      ...formValues,
      locationId: formValues.locationId.value,
      pricePerAxle,
      taxPrePaymentPerAxle,
      electronic,
      isExtraordinary: Boolean(formValues.isExtraordinary),
      provia: Boolean(formValues.provia),
      electronicPricePerAxle: electronic ? pricePerAxle : null,
      electronicTaxPrePaymentPerAxle: electronic ? taxPrePaymentPerAxle : null,
      businessId: formValues.business ? formValues.business.value : null
    };

    dispatchPostToll(newFormValues);
  };

  const content = <TollForm onSubmit={onSubmit} />;

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Nuevo Registro de Peaje"
      subtitle="Crear nuevo registro de peaje"
      content={content}
    />
  );
};

NewToll.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchPostToll: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchPostToll: postToll,
};

const mapStateToProps = ({ RouteUnit }) => ({
  breadcrumbs: [
    ...RouteUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Peajes',
      href: TOLL_PATH,
    },
    {
      text: 'Nuevo',
      href: '',
    },
  ],
});

export default connect(mapStateToProps, mapDispatchToProps)(NewToll);
